// Disabling as this just needs to exist to appease TS

const checkIfWalletAvailable = () => {
  return false;
};

export default checkIfWalletAvailable;
